module.exports = __webpack_public_path__ + "img/screenAnalyticsCustom.a37a9940.png";